import {storePdf} from "./SolutionService";

export const storeFile = async (url: string, pdfFile: File): Promise<void> => {
    try {
        await storePdf(url, pdfFile);
    } catch {
        console.log("Error storing pdf");
    }
}
